/* JFK Grocery: display-only deal preview. Real cart and checkout discounts require Shopify backend setup. */
(function () {
  function init() {
    document.querySelectorAll('.jfk-advanced-deal').forEach(function (panel) {
      if (panel.dataset.ready === '1') return;
      var section = panel.closest('.shopify-section') || document;
      var id = panel.dataset.sectionId;
      var input = document.getElementById('Quantity-' + id);
      var form = document.getElementById('product-form-' + id);
      if (!input || !form) return;
      var minimum = Number(panel.dataset.min);
      var bundle = Number(panel.dataset.bundleCents);
      var variants;
      try { variants = JSON.parse(panel.dataset.variants || '[]'); } catch (e) { return; }
      if (minimum < 2 || bundle <= 0) return;
      panel.dataset.ready = '1';
      var money = function (cents) { return new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents/100); };
      function refresh() {
        var qty = Math.max(1, Math.floor(Number(input.value) || 1));
        var field = form.querySelector('[name="id"]');
        var variant = variants.find(function (v) { return field && String(v.id) === String(field.value); }) || variants[0];
        if (!variant) return;
        var regular = qty * Number(variant.price);
        var estimated = Math.round(qty * bundle / minimum);
        var eligible = qty >= minimum && estimated < regular;
        var total = eligible ? estimated : regular;
        panel.querySelector('[data-deal-total]').textContent = money(total);
        panel.querySelector('[data-deal-description]').textContent = qty + ' item' + (qty === 1 ? '' : 's') + ' estimated total';
        panel.querySelector('[data-deal-saving]').textContent = eligible ? 'Potential savings: ' + money(regular - total) : 'Add ' + Math.max(0, minimum - qty) + ' more to unlock deal';
        panel.querySelectorAll('[data-pick]').forEach(function(btn){
          btn.classList.toggle('selected', Number(btn.dataset.pick) === (qty >= minimum ? minimum : 1));
        });
      }
      function setQuantity(q) {
        input.value = String(Math.max(1, q));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        refresh();
      }
      panel.querySelectorAll('[data-pick]').forEach(function (button) {
        button.addEventListener('click', function () { setQuantity(Number(button.dataset.pick)); });
      });
      input.addEventListener('input', refresh);
      input.addEventListener('change', refresh);
      form.addEventListener('change', function () { requestAnimationFrame(refresh); });
      section.addEventListener('change', function () { requestAnimationFrame(refresh); });
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
